import React from 'react'
import './ProjectHeading.css'
const ProjectHeading = ({title}) => {
  return (
   <h2 className='ProjectHeading'>{title}</h2>
  )
}

export default ProjectHeading